var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[(!_vm.hasErr)?_c('img',{attrs:{"src":_vm.url,"alt":""},on:{"error":_vm.onError,"onload":_vm.onLoad,"click":_vm.handleClick}}):_c('img',{attrs:{"src":require("./../../assets/images/empty_data.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }